import { Line } from 'vue-chartjs';

export default {
  name: 'header-chart',
  extends: Line,
  props: ['data', 'labels', 'halloween'],
  mounted() {
    const chartColor = this.halloween ? '#ffad4a' : '#FFFFFF';
    const ctx = document.getElementById(this.chartId).getContext('2d');
    const gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    gradientStroke.addColorStop(0, this.halloween ? '#ff691f' : '#80b6f4');
    gradientStroke.addColorStop(1, chartColor);

    const gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
    gradientFill.addColorStop(0, this.halloween ? 'rgba(255, 105, 31, 0)' : 'rgba(128, 182, 244, 0)');
    gradientFill.addColorStop(1, this.halloween ? 'rgba(255, 133, 39, 0.32)' : 'rgba(255, 255, 255, 0.24)');
    this.renderChart(
      {
        labels: this.labels || [],
        datasets: [
          {
            label: 'Commandes Livrées',
            borderColor: chartColor,
            backgroundColor: gradientFill,
            pointBorderColor: chartColor,
            pointBackgroundColor: this.halloween ? '#361342' : '#1e3d60',
            pointHoverBackgroundColor: this.halloween ? '#361342' : '#1e3d60',
            pointHoverBorderColor: chartColor,
            pointBorderWidth: 1,
            pointHoverRadius: 7,
            pointHoverBorderWidth: 2,
            pointRadius: 5,
            fill: true,
            borderWidth: 2,
            data: this.data[0] || []
          },
          // {
          //   label: 'Commandes créés',
          //   borderColor: '#2CA8FF',
          //   backgroundColor: gradientFill,
          //   pointBorderColor: '#2CA8FF',
          //   pointBackgroundColor: '#1e3d60',
          //   pointHoverBackgroundColor: '#1e3d60',
          //   pointHoverBorderColor: chartColor,
          //   pointBorderWidth: 1,
          //   pointHoverRadius: 7,
          //   pointHoverBorderWidth: 2,
          //   pointRadius: 5,
          //   fill: true,
          //   borderWidth: 2,
          //   data: this.data[1] || []
          // }
        ]
      },
      {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: '#fff',
          titleFontColor: '#333',
          bodyFontColor: '#666',
          bodySpacing: 4,
          xPadding: 12
        },
        legend: {
          position: 'bottom',
          fillStyle: '#FFF',
          display: false
        },
        title: {
          display: false,
          position: 'top',
          lineHeight: 0.5,
          fontSize: 24,
          fontColor: '#FFF',
          text: 'Bienvenue sur Process V2'
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: 'rgba(255,255,255,0.4)',
                fontStyle: 'bold',
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: 'rgba(255,255,255,0.1)',
                zeroLineColor: 'transparent'
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                zeroLineColor: 'transparent',
                display: false
              },
              ticks: {
                padding: 10,
                fontColor: 'rgba(255,255,255,0.4)',
                fontStyle: 'bold'
              }
            }
          ]
        }
      }
    );
  }
};
